"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labsMapper = labsMapper;
exports.labDetailsMapper = labDetailsMapper;
exports.labRequisitionsMapper = labRequisitionsMapper;
function labsMapper(labs) {
    return labs.map(l => (Object.assign({}, l)));
}
function labDetailsMapper(labDetails) {
    return Object.assign({}, labDetails);
}
function labRequisitionsMapper(labRequisitions) {
    return labRequisitions.map(r => (Object.assign({}, r)));
}
